import store from '@/store'

export function streamGraphAsk({ question, language, conversationId, onStart, onProgress, onToken, onFinal, onError }) {
  const controller = new AbortController()

  ;(async () => {
    let response
    try {
      response = await fetch(`${window.__env.VUE_APP_BASE_URL}/v1/detection_event/graph-ask/stream`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'text/event-stream',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'X-localization': store.getters['user/getPreferences'].lang,
          module: 'SBO',
        },
        body: JSON.stringify({
          question,
          language,
          ...(conversationId ? { conversation_id: conversationId } : {}),
        }),
        signal: controller.signal,
      })
    } catch (e) {
      if (e.name !== 'AbortError') onError({ code: 'network_error', message: e.message })
      return
    }

    // 401 / 422 / 429 arrive as plain JSON before the stream opens.
    if (!response.ok) {
      const data = await response.json().catch(() => ({}))
      onError(data.error || { code: `http_${response.status}`, message: data.message || response.statusText })
      return
    }

    const reader = response.body.getReader()
    const decoder = new TextDecoder()
    let buffer = ''
    let finished = false

    try {
      while (true) {
        const { value, done } = await reader.read()
        if (done) break
        buffer += decoder.decode(value, { stream: true }).replace(/\r\n/g, '\n')

        let sep
        while ((sep = buffer.indexOf('\n\n')) !== -1) {
          const raw = buffer.slice(0, sep)
          buffer = buffer.slice(sep + 2)

          let event = 'message'
          const dataLines = []
          for (const line of raw.split('\n')) {
            if (line.startsWith(':')) continue
            if (line.startsWith('event:')) event = line.slice(6).trim()
            else if (line.startsWith('data:')) dataLines.push(line.slice(5).trimStart())
          }
          if (!dataLines.length) continue

          const data = JSON.parse(dataLines.join('\n'))
          if (event === 'start') onStart && onStart(data)
          else if (event === 'progress') onProgress && onProgress(data)
          else if (event === 'token') onToken && onToken(data.text)
          else if (event === 'final') {
            finished = true
            onFinal && onFinal(data)
          } else if (event === 'error') {
            finished = true
            onError(data.error)
          }
        }
      }

      if (!finished) onError({ code: 'stream_interrupted', message: '' })
    } catch (e) {
      if (e.name !== 'AbortError') onError({ code: 'stream_interrupted', message: e.message })
    }
  })()

  return () => controller.abort()
}
